<template>
  <section class="member-info">
    <h1>{{ $t('member-information.key001') }}</h1>
    <RewardProgress v-show="!registerEdit" />

    <MemberProfile @update="updateMember" />
  </section>
  <Loading v-show="loading"></Loading>
</template>

<script>
import { ref, computed, onMounted, provide } from 'vue';
import { useStore } from 'vuex';
import MemberProfile from '@/components/memberCenter/memberInfo/MemberProfile.vue';
import RewardProgress from '@/components/memberCenter/memberInfo/RewardProgress.vue';
import Loading from '@/components/Loading.vue';
import { getUserInfo } from '@/api/apiService';

export default {
  name: 'MemberInfo',
  components: {
    MemberProfile,
    RewardProgress,
    Loading,
  },
  props: {
    registerEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const mode = ref('display');
    const store = useStore();
    const jwt = computed(() => store.state.jwt);
    const loading = ref(false);
    const DEFAULT_AVATAR = 'https://d2uz35uzla1hiz.cloudfront.net/UserIcon/ch.png';

    const toggleMode = () => {
      mode.value = mode.value === 'display' ? 'edit' : 'display';
    };

    const updateMember = (newData) => {
      userData.value = { ...newData };
      toggleMode();
    };

    // userData
    const userData = ref({
      uid: '',
      name: '',
      nickname: '',
      currentLoginMethod: 0,
      phone: '',
      gender: 0,
      birth: '',
      area: '',
      city: '',
      contactEmail: '',
      agreeMail: false,
      account: '',
      avatar: DEFAULT_AVATAR,
      interests: [],
      address: {
        county: '',
        zipCode: '',
        district: '',
        addressDetail: '',
      },
      collectionStage: 0,
      quantityFilled: 0,
      FullAddress: '',
      legalGuardianEmail: '',
      legalGuardianName: '',
    });

    const fetchUserInfo = async () => {
      try {
        loading.value = true;
        const userDataResponse = await getUserInfo(jwt.value, true);
        if (!userDataResponse) return;
        Object.assign(userData.value, {
          uid: userDataResponse.uid || '',
          name: userDataResponse.name || '',
          nickname: userDataResponse.nickname || '',
          currentLoginMethod: userDataResponse.currentLoginMethod || 0,
          phone: userDataResponse.phone || '',
          gender: userDataResponse.gender || 0,
          birth: userDataResponse.birth || '',
          area: userDataResponse.area || '',
          city: userDataResponse.city || '',
          contactEmail: userDataResponse.contactEmail || '',
          agreeMail: userDataResponse.agreeMail || false,
          account: userDataResponse.account || '',
          avatar: userDataResponse.avatar || DEFAULT_AVATAR,
          interests: userDataResponse.interests || [],
          address: {
            county: userDataResponse.address?.county || '',
            zipCode: userDataResponse.address?.zipCode || '',
            district: userDataResponse.address?.district || '',
            addressDetail: userDataResponse.address?.addressDetail || '',
          },
          collectionStage: userDataResponse.collectionStage || 0,
          quantityFilled: userDataResponse.quantityFilled || 0,
          legalGuardianEmail: userDataResponse.legalGuardianEmail || '',
          legalGuardianName: userDataResponse.legalGuardianName || '',
        });

        userData.value.FullAddress = `${userData.value.address.zipCode}${userData.value.address.county}${userData.value.address.district}${userData.value.address.addressDetail}`;
      } catch (error) {
        console.error('Error fetching user info:', error);
      } finally {
        loading.value = false;
      }
    };

    // 在組件掛載時自動獲取會員資料
    onMounted(fetchUserInfo);

    provide('userData', userData);
    provide('loading', loading);
    provide('refreshUserData', fetchUserInfo);

    return {
      mode,
      userData,
      toggleMode,
      updateMember,
      loading,
    };
  },
};
</script>

<style lang="scss"></style>
